import { render, staticRenderFns } from "./Finance-expense.vue?vue&type=template&id=812a0a6e&"
import script from "./Finance-expense.vue?vue&type=script&lang=js&"
export * from "./Finance-expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports